import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=3585d5a8&scoped=true&"
import script from "./Authorized.vue?vue&type=script&lang=ts&"
export * from "./Authorized.vue?vue&type=script&lang=ts&"
import style0 from "./Authorized.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Authorized.vue?vue&type=style&index=1&id=3585d5a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3585d5a8",
  null
  
)

export default component.exports